import { useState } from 'react';
import BioScience from './bio-science'
import BrewingEquipment from './brewing-equipment'
import BrewingMethods from './brewing-methods'
import LegalSpecifications from './legal-specifications'
import PersonalPreference from './personal-preference'
import RegionalTerminology from './regional-terminology'

export const typesOfQuestions = [PersonalPreference, BioScience, LegalSpecifications, BrewingMethods, RegionalTerminology, BrewingEquipment]
export const catagories = typesOfQuestions.map((obj) => obj.catagory)

export {PersonalPreference, BioScience, BrewingMethods, LegalSpecifications, RegionalTerminology, BrewingEquipment}